const authorizedB2COrdersUsers = [
  'adriana.molvinger@foodforjoe.es',
  'dana@foodforjoe.es',
  'data@foodforjoe.com',
];

export default authorizedB2COrdersUsers;
